export function toSnakeCase(str: string): string {
    return str
        // Replace spaces and hyphens with underscores
        .replace(/[\s-]+/g, '_')
        // Insert underscore before uppercase letters (except at the start)
        .replace(/([a-z])([A-Z])/g, '$1_$2')
        // Convert everything to lowercase
        .toLowerCase();
}

/**
 * Converts a snake_case string to Title Case.
 * Example: "this_is_a_test" -> "This Is A Test"
 */
export function snakeToTitleCase(str: string): string {
    return str
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}

/**
 * Escapes HTML special characters to prevent XSS attacks.
 * Use this function before setting content with dangerouslySetInnerHTML.
 *
 * @param unsafe - The string that may contain HTML special characters
 * @returns The escaped string safe for HTML rendering
 *
 * @example
 * ```ts
 * const userInput = '<script>alert("xss")</script>';
 * const safe = escapeHtml(userInput);
 * // Returns: '&lt;script&gt;alert(&quot;xss&quot;)&lt;/script&gt;'
 * ```
 */
export function escapeHtml(unsafe: string): string {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}
